<template>
    <div class="flex">
        <div class="flex w-full pl-4">
            <div class="col grid-margin mb-3">
                <div class="flex mb-2">
                    <div class="w-1/3">
                        <div id="declarability-title" class="card-title" style="display: none;">Declaratie overzicht</div>
                    </div>
                    <div :class="employer ? 'w-1/2' : 'w-1/3'">
                        <div class="flex selection-off">
                            <div class="w-1/6"></div>
                            <div class="w-1/4 text-center today" v-if="!employer">
                                <span class="badge rounded-pill text-white" style="background-color: #E65251;">{{ filteredRows.length }}</span>
                                Afgekeurd
                            </div>
                            <div class="w-1/4 text-center today" v-if="employer"></div>
                            <div class="w-1/12 text-right">
                                <i class="fas fa-chevron-left month-chrevron" @click="previousPeriod()"></i>
                            </div>
                            <div class="month-name w-1/3 text-center p-0" v-if="range === 0">Week {{ lastSelectedDate.getWeek() - 1 }} ({{ lastSelectedDate.getFullYear() }})</div>
                            <div class="month-name w-1/3 text-center p-0" v-if="range === 1">{{ monthNames[lastSelectedDate.getMonth()] }} {{ lastSelectedDate.getFullYear() }}</div>
                            <div class="month-name w-1/3 text-center p-0" v-if="range === 2">{{ lastSelectedDate.getFullYear() }}</div>
                            <div class="w-1/12 text-left">
                                <i class="fas fa-chevron-right month-chrevron" @click="nextPeriod()"></i>
                            </div>
                        </div>
                    </div>
                    <div class="w-1/6">
                        <select id="viewType" @change="changeRange" v-model="range" class="form-control custom-select">
                            <option :value="0">Week</option>
                            <option selected :value="1">Maand</option>
                            <option :value="2">Jaar</option>
                        </select>
                    </div>
                    <div class="w-1/6" v-if="!employer">
                        <a href="/employee/declarability/new" class="btn btn-secondary" style="color: white;">Declaratie invullen</a>
                    </div>
                </div>
                <div class="flex" style="min-height: 500px;">
                    <div class="w-1/6 border rounded-left text-white pt-3" style="background-color: #5933C6" v-if="employer">
                        <div class="flex pt-3" style="height: 40px;">
                            <h4 class="w-11/12 offset-1 font-weight-bold">Medewerker</h4>
                        </div>
                        <div class="flex mt-4" v-for="row in rows" v-bind:key="row.id">
                            <h6 class="w-11/12 offset-1">{{ row.name }}</h6>
                        </div>
                    </div>
                    <div class="rounded-right card card-body" :class="!employer ? 'rounded-left w-full' : 'w-10/12'">
                        <div id="declarability-content" class="flex flex-wrap pt-2">
                            <div class="flex w-full pb-2">
                                <div class="w-1/4 text-center">
                                    <h5 style="color:#5933C6;">
                                        Datum
                                    </h5>
                                </div>
                                <div class="w-1/4 text-center">
                                    <h5 style="color:#5933C6;">
                                        Bedrag
                                    </h5>
                                </div>
                                <div class="w-1/4 text-center">
                                    <h5 style="color:#5933C6;">
                                        Beschrijving
                                    </h5>
                                </div>
                                <div class="w-1/4 text-center">
                                    <h5 style="color:#5933C6;">
                                        Status
                                    </h5>
                                </div>
                            </div>
                            <div class="flex flex-wrap w-full" v-if="rows.length > 0">
                                <a class="flex w-full declaration-row" v-for="(row, index) in rows" v-bind:key="index" style="" :href="employer ? '/employer/declarability/' + row.id : '/employee/declarability/' + row.id">
                                    <div class="w-1/4 text-center border-right pt-3 pb-2">
                                        {{ toDutchDate(convertMysqlToDate(row.date)) }}
                                    </div>
                                    <div class="w-1/4 text-center border-left border-right pt-3 pb-2">
                                        {{ formatTotalPrice(row.total) }}
                                    </div>
                                    <div class="w-1/4 text-center border-left border-right pt-3 pb-2">
                                        {{ trimDescription(row.description) }}
                                    </div>
                                    <div class="w-1/4 text-center border-left pt-3 pb-2">
                                        <div class="flex w-full">
                                            <div class="offset-2 w-1/12"><div class="mt-1" :class="row.status == 0 ? 'statusPending' : (row.status == 1 ? 'statusAccepted' : 'statusRejected')" style="height: 15px; width: 15px;"></div></div>
                                            <div class="w-2/3">{{ status[row.status] }}</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="flex w-full" v-else>
                                <div class="w-full lg:w-11/12 border-right pt-3 pb-2">
                                    Er zijn nog geen declaraties toegevoegd
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            employer: {
                default: false,
                type: Boolean,
            },
            new_declaration_url: {
                required: false,
            },
            declarations: Array,
        },
        data: function () {
            return {
                range: 1,
                ranges: {
                    0: "Week",
                    1: "Maand",
                    2: "Jaar",
                },
                range_days: {
                    0: 7,
                    1: 31,
                    2: 365,
                },
                status: {
                    0: 'Ingediend',
                    1: 'Goedgekeurd',
                    2: 'Afgekeurd',
                },
                monthNames: [
                    "Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December",
                ],
                lastSelectedDate: new Date(),
                rows: [],
            }
        },
        computed: {
            filteredRows() {
                const rows = Array.from(this.rows);
                return rows.filter(obj => obj.status === 2);
            }
        },
        methods: {
            loadPeriod: function (startDate, endDate) {
                axios
                    .get(`/employe${this.employer ? 'r' : 'e'}/declarability/?startDate=${startDate.mysqlFormat()}&endDate=${endDate.mysqlFormat()}`)
                    .then((response) => {
                        this.rows = response.data;
                    })
                    .catch(error => {
                        console.error(error);
                    })
                ;
            },
            changeRange: function () {
                switch (this.range) {
                    case 0:
                        let startOfWeek = this.lastSelectedDate.getStartOfWeek();
                        let endOfWeek = this.lastSelectedDate.getEndOfWeek();

                        this.lastSelectedDate = startOfWeek;
                        this.loadPeriod(startOfWeek, endOfWeek);
                        break;
                    case 1:
                        let startOfMonth = this.lastSelectedDate.getStartOfMonth();
                        let endOfMonth = this.lastSelectedDate.getEndOfMonth();

                        this.lastSelectedDate = startOfMonth;
                        this.loadPeriod(startOfMonth, endOfMonth);
                        break;
                    case 2:
                        let startOfYear = this.lastSelectedDate.getStartOfYear();
                        let endOfYear = this.lastSelectedDate.getEndOfYear();

                        this.lastSelectedDate = startOfYear;
                        this.loadPeriod(startOfYear, endOfYear);
                        break;
                    default:
                        break;
                }
            },
            nextPeriod: function () {
                switch (this.range) {
                    case 0:
                        this.lastSelectedDate = this.lastSelectedDate.addDays(7);
                        break;
                    case 1:
                        this.lastSelectedDate = this.lastSelectedDate.addMonths(1);
                        break;
                    case 2:
                        this.lastSelectedDate = this.lastSelectedDate.addYears(1);
                        break;
                    default:
                        break;
                }

                this.changeRange();
            },
            previousPeriod: function () {
                switch (this.range) {
                    case 0:
                        this.lastSelectedDate = this.lastSelectedDate.removeDays(7);
                        break;
                    case 1:
                        this.lastSelectedDate = this.lastSelectedDate.removeMonths(1);
                        break;
                    case 2:
                        this.lastSelectedDate = this.lastSelectedDate.removeYears(1);
                        break;
                    default:
                        break;
                }

                this.changeRange();
            },
            convertMysqlToDate: function (date) {
                let dateParts = date.split('-');
                return new Date(dateParts[0], dateParts[1] - 1, dateParts[2].substr(0,2));
            },
            toDutchDate: function (date) {
                return date.toLocaleDateString('nl', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                });
            },
            formatTotalPrice: function (total) {
                const formatter = new Intl.NumberFormat('nl-NL', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                });

                return formatter.format(total).replace(",00", ",-");
            },
            trimDescription: function (description) {
                const length = 70;

                if (description.length < length){
                    return description;
                } else {
                    return description.substring(0, length) + '...';
                }
            }
        },
        mounted() {
            this.lastSelectedDate = new Date().removeMonths(1);
            this.rows = this.declarations;
        }
    }
</script>

<style scoped>

</style>
